const words = ["Fresh fruit", "Crisp veges", "Packed in Nelson", "Delivered to your door", "Fresh every week", "Seasonal & local"];

const Row = ({ hidden }) => (
  <div className="marquee-track flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-6xl font-extrabold tracking-tight sm:text-8xl ${i % 2 ? "text-outline" : "text-[#1B2A1C]"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="h-8 w-8 fill-[#EAB308] sm:h-10 sm:w-10"><path d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12C7 11 11 7 12 0z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-[#1B2A1C]/10 bg-[#F3EEDF] py-10 sm:py-14" data-testid="marquee">
    <div className="flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
